import React from "react";
import { motion } from "framer-motion";
import { FaHeart, FaArrowUp, FaGithub, FaLinkedin, FaEnvelope } from "react-icons/fa";
import "./Footer.css";

const Footer: React.FC = () => {
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  const currentYear = new Date().getFullYear();

  const socialLinks = [
    {
      icon: <FaGithub />,
      name: "GitHub",
      url: "https://github.com/oscaralvarezrua",
      color: "#333",
    },
    {
      icon: <FaLinkedin />,
      name: "LinkedIn",
      url: "https://linkedin.com/in/oscaralvarezrua",
      color: "#0077b5",
    },
    {
      icon: <FaEnvelope />,
      name: "Email",
      url: "mailto:oscaralvarez4c@gmail.com",
      color: "#b3ade0",
    },
  ];

  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-content">
          <motion.div className="footer-main" initial={{ opacity: 0, y: 30 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.8 }}>
            <div className="footer-info">
              <h3>Oscar Alvarez</h3>
              <p>Desarrollador Full Stack apasionado por crear experiencias digitales únicas.</p>
            </div>

            <div className="footer-links">
              <h4>Enlaces Rápidos</h4>
              <ul>
                <li>
                  <a href="#home">Inicio</a>
                </li>
                <li>
                  <a href="#about">Sobre Mí</a>
                </li>
                <li>
                  <a href="#skills">Habilidades</a>
                </li>
                <li>
                  <a href="#projects">Proyectos</a>
                </li>
                <li>
                  <a href="#contact">Contacto</a>
                </li>
              </ul>
            </div>

            <div className="footer-contact">
              <h4>Contacto</h4>
              <p>oscaralvarez4c@gmail.com</p>
              <p>+34 600 23 57 14</p>
              <p>Galicia, España</p>
            </div>

            <div className="footer-social">
              <h4>Sígueme</h4>
              <div className="social-icons">
                {socialLinks.map((social, index) => (
                  <motion.a key={social.name} href={social.url} target="_blank" rel="noopener noreferrer" className="social-icon" style={{ "--social-color": social.color } as React.CSSProperties} initial={{ opacity: 0, scale: 0 }} animate={{ opacity: 1, scale: 1 }} transition={{ duration: 0.5, delay: 0.2 + index * 0.1 }} whileHover={{ scale: 1.1 }} aria-label={`Visitar ${social.name}`}>
                    {social.icon}
                  </motion.a>
                ))}
              </div>
            </div>
          </motion.div>

          <motion.div className="footer-bottom" initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ duration: 0.8, delay: 0.4 }}>
            <div className="footer-copyright">
              <p>
                © {currentYear} Oscar Alvarez. Todos los derechos reservados.
                <span className="made-with">
                  Hecho con <FaHeart className="heart-icon" /> en España.
                </span>
              </p>
            </div>

            <button className="scroll-to-top" onClick={scrollToTop} aria-label="Volver arriba">
              <FaArrowUp />
            </button>
          </motion.div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
